export function waLink(number, message) {
  const num = (number || "918382890707").replace(/\D/g, "");
  const text = encodeURIComponent(message || "Hi NewStarAds, I want to discuss YouTube promotion for my channel/video.");
  return `https://wa.me/${num}?text=${text}`;
}

export function trackEvent(name, params = {}) {
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) window.fbq("trackCustom", name, params);
  } catch (e) {}
}

export function trackConversion(sendTo, value) {
  try {
    if (window.gtag && sendTo) {
      const params = { send_to: sendTo };
      if (value) params.value = value;
      window.gtag("event", "conversion", params);
    }
  } catch (e) {}
}

export function getUTM() {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
    landing_page: window.location.pathname,
    device: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
  };
}
